// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"da36cf4f","598":"becaa9c4"}[chunkId] + ".chunk.js";
};